import React from 'react';
import PropTypes from "prop-types";
import { withLocation } from "../../../utils/router";

export class ResizeOnUpdate extends React.Component {
  componentDidUpdate(prevProps) {
    if (!this.props.location || this.props.location !== prevProps.location) {
      const resizeEvent = window.document.createEvent('UIEvents');
      resizeEvent.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(resizeEvent);
    }
  }

  render() {
    return this.props.children;
  }
}

ResizeOnUpdate.propTypes = {
  location: PropTypes.object.isRequired
};

export default withLocation(ResizeOnUpdate);
